<template>
    <v-dialog v-model="dialog" max-width="500" persistent>
        <v-card>
            <v-card-title class="primary white--text title">
                <span v-if="activeItem.equipment_id">{{ 'Edit Equipment'|translate }}</span>
                <span v-if="!activeItem.equipment_id">{{ 'Add Equipment'|translate }}</span>
            </v-card-title>
            <v-card-text>
                <v-text-field :label="'Equipment Name'|translate" autofocus
                              v-model="activeItem.equipment_name"></v-text-field>
                <v-combobox
                    :items="possibleEquipTypes"
                    :label="'Equipment Type'|translate"
                    v-model="activeItem.equipment_type"
                ></v-combobox>
                <draggable v-model="activeItem.equipment_tags" group="a">
                    <v-chip close v-for="(j, index) in activeItem.equipment_tags"
                            @input="activeItem.equipment_tags.splice(index, 1)"
                            label
                    >
                        {{ j }}
                    </v-chip>
                </draggable>
                <v-layout row>
                    <v-text-field :label="'Add Tag'|translate" type="text"
                                  v-model="newTag"></v-text-field>
                    <v-btn color="primary" :disabled="!newTag||newTag==''"
                           @click="activeItem.equipment_tags.push(newTag); newTag=null">{{ 'Add'|translate }}
                    </v-btn>
                </v-layout>
                <v-text-field :label="'Floor'|translate" v-model="activeItem.floor"></v-text-field>
                <facility-selector v-model="activeItem.facility_name"></facility-selector>
                <v-textarea :label="'Notes'|translate" v-model="activeItem.notes">
                </v-textarea>
                <graphic-selector v-model="activeItem.graphic_id"></graphic-selector>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary" @click="addRecord(true)" :disabled="!$can('update', 'Equipment')">
                    {{ 'Save'|translate }}
                </v-btn>
                <v-btn @click="initializeVar(true)">{{ 'Cancel'|translate }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import FacilitySelector from '../FacilitySelector'
import GraphicSelector from "../GraphicSelector";
import {putEquipment} from '../../helper'
import draggable from 'vuedraggable'

export default {
    components: {FacilitySelector, draggable, GraphicSelector},
    props: {
        value: {type: Boolean, default: true},
        item: {type: Object, default: null}
    },
    watch: {
        item(item) {
            this.initializeVar()
            if (item) {
                this.activeItem = this.item
            }
        },
        value() {
            if (this.item) {
                this.activeItem = this.item
            }
            if (!this.activeItem.equipment_id) {
                this.initializeVar()
            }
            if (!this.activeItem.equipment_tags) {
                this.activeItem.equipment_tags = []
            }
            if (this.dialog != this.value) {
                this.dialog = this.value
                //this.initializeVar()
            }
        },
        dialog() {
            this.$emit('input', this.dialog)
        }
    },
    computed: {
        possibleEquipTypes(){
            return [...new Set(this.combinations.map(x=>x.equipment_type))].sort()
        },
    },
    data() {
        return {
            dialog: false,
            newTag: null,
            combinations:[],
            activeItem: {
                equipment_id: null,
                equipment_name: '',
                equipment_type: '',
                equipment_tags: [],
                floor: '',
                notes: '',
                facility_name: '',
                meta: '',
                graphic_id: null,

            },

        }
    },
    mounted(){
        let combinations=this.$store.state.pointsListStore.pointsList.points_list.map(sensor=>{return{
            sensor_name:sensor.sensor_name,
            equipment_name:sensor.equipment_name,
            equipment_type:this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].equipment_type,
            equipment_tags:this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].equipment_tags ? this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].equipment_tags : [],
            floor:this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].floor,
        }})
        this.combinations=JSON.parse(JSON.stringify(combinations))
    },
    methods: {
        initializeVar(close) {
            this.newTag = null
            this.activeItem = {
                equipment_id: null,
                equipment_name: '',
                equipment_type: '',
                equipment_tags: [],
                floor: '',
                notes: '',
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                meta: '',
                graphic_id: null,

            }
            if (close) {
                this.dialog = false;
            }
        },
        async addRecord(close) {
            await putEquipment(
                {
                    'equipment_id': this.activeItem.equipment_id,
                    'equipment_name': this.activeItem.equipment_name,
                    'floor': this.activeItem.floor,
                    'equipment_type': this.activeItem.equipment_type,
                    'equipment_tags': this.activeItem.equipment_tags,
                    'facility_name': this.activeItem.facility_name,
                    'notes': this.activeItem.notes,
                    'meta': this.activeItem.meta,
                    'graphic_id': this.activeItem.graphic_id ? this.activeItem.graphic_id : null,

                }
            )
            this.$emit('reloadequipments', this.dialog)
            if (close) {
                this.dialog = false;
            }
        }
    },
    name: 'EquipmentRecordDialog'
}
</script>

<style scoped>

</style>
